import Icon from '../components/Icon.vue'

Icon.register({
  'chess-king': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 448c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-352c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h352zM416 160c17.7 0 32 14.3 32 32 0 2.7-0.7 7-1.5 9.5l-73.1 214.5h-298.9l-73.1-214.5c-0.8-2.6-1.5-6.8-1.5-9.5 0-17.7 14.3-32 32-32h160v-48h-40c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h40v-40c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v40h40c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-40v48h160z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chess-king.js
// module id = 1182
// module chunks = 0